module.exports = __webpack_public_path__ + "assets/d8b2a3f70264ba6a032410ea4ffbdbfd.svg";